/**
 * Links that come from outside LY360 (a platform's post URL, a customer's message): only web addresses are made
 * clickable, so a `javascript:` or `data:` link can never run in LY360.
 */
export function safeHref(url: string | null | undefined): string | null {
  if (!url) return null;
  try {
    const u = new URL(url);
    return u.protocol === 'https:' || u.protocol === 'http:' ? u.toString() : null;
  } catch {
    return null;
  }
}
